import { useEffect, useState } from "react";
import arrowLeft from "../assets/img/arrow-left.svg";
import { haveValue } from "../helper/common";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
const FilePreviewModal = ({ show, onClose, files = [], showIndex }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentFile, setcurrentFile] = useState(
    files[currentIndex]?.file_name
  );

  useEffect(() => {
    if (haveValue(showIndex)) {
      setCurrentIndex(showIndex);
    }
  }, [showIndex]);

  useEffect(() => {
    setcurrentFile(files[currentIndex]?.file_name);
  }, [currentIndex, files]);

  // console.log(currentIndex, "showIndex", showIndex);

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex < files.length - 1) setCurrentIndex(currentIndex + 1);
  };

  const fileUrl = (currentFile ?? "").endsWith(".csv")
    ? "/images/csv-dummy.svg"
    : `${process.env.REACT_APP_SERVER_URL}/uploads/${currentFile}`;
  const isImage =
    /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(currentFile) ||
    (currentFile ?? "").endsWith(".csv");

  console.log("current url", fileUrl, "currentFile", currentFile);
  return (
    <div
      className={`modal wrapper-modal file-viewer-modal fade ${
        show ? "show d-block" : ""
      }`}
      tabIndex="-1"
      role="dialog"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="modal-dialog gallery-modal modal-xl modal-dialog-scrollable"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between align-items-center modalHeader">
            <h5 className="modal-title">
              Preview File {currentIndex + 1} of {files.length}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={(e) => {
                // setCurrentIndex(0);
                onClose();
              }}
            ></button>
          </div>

          <div className="modal-body text-center">
            {isImage ? (
              <Zoom>
                <img
                  src={fileUrl}
                  alt="Zoomed Image"
                  style={{
                    width: "100vw",
                    maxHeight: "63vh",
                    objectFit: "contain",
                  }}
                />
              </Zoom>
            ) : (
              <iframe
                src={fileUrl}
                width="100%"
                height="100%"
                className="preview-file-model"
                style={{ border: "none" }}
              />
            )}
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <button
              type="button"
              className={`arrowButton ${
                currentIndex !== 0 ? "cursor-pointer" : "opacity-25"
              } `}
              onClick={handlePrev}
              disabled={currentIndex === 0}
            >
              <img src={arrowLeft} alt="" />
            </button>
            <p className="file-name">{currentFile}</p>
            <button
              type="button"
              className={`arrowButton ${
                currentIndex !== files.length - 1
                  ? "cursor-pointer"
                  : "opacity-25"
              } `}
              onClick={handleNext}
              disabled={currentIndex === files.length - 1}
            >
              <img
                src={arrowLeft}
                alt=""
                style={{ transform: "rotate(180deg)" }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilePreviewModal;
